






















import Enumerable from "linq";
import { Component, Mixins, Watch } from "vue-property-decorator";
import { Table } from "element-ui";
import {
  ModelEditableMixin,
} from "../../../../../../base/components/system/mixins";
import { FileToBase64TextConverter } from "../../../../../../base/utilities";
import { FormatStructureEditableMixin } from "../../mixins";
import { DomainRegistry } from "../../../../../domain/";
import {
  IEditableFormatReferenceFile,
  StoragePlaceKinds,
} from "../../../../../domain/editableFormat";

@Component
export default class FormatPropertyReferenceFileEditTool extends Mixins(ModelEditableMixin, FormatStructureEditableMixin) {
  isUploading: boolean = false;
  tableData: IEditableFormatReferenceFile[] = [];

  $refs!: {
    input: HTMLInputElement,
    table: Table,
  };

  private isUpdatedReferenceFiles: boolean = false;

  mounted(): void {
    this.tableData = this.referenceFiles.slice();
    this.$refs.table.toggleAllSelection();
  }

  addReferenceFiles(files: FileList): void {
    Enumerable.from(files).forEach((e, i) => this.uploadReferenceFile(e));
  }

  private uploadReferenceFile(file: File): void {
    FileToBase64TextConverter.convert(file, p => this.upload(file.name, p), () => {
      this.$error(
        "読み込み失敗",
        "ファイルの読み込みに失敗しました。",
      );
    });
  }

  private upload(fileName: string, contents: string) {
    this.isUploading = true;
    const registry = DomainRegistry.instance;
    registry.editableFormat.getFormatRepository().uploadReferenceFile(fileName, contents)
    .then(fileKey => {
      const data = {
        key: fileKey,
        name: fileName,
        storagePlace: StoragePlaceKinds.Cache,
      };
      this.tableData.push(data);
      this.$refs.table.toggleRowSelection(data, true);
    })
    .catch(e => {
      this.$error(
        "アップロード失敗",
        "ファイルのアップロードに失敗しました。",
        e,
      );
    })
    .finally(() => {
      this.isUploading = false;
    });
  }

  openDialog(): void {
    this.$refs.input.click();
  }

  selectionChange(selection: IEditableFormatReferenceFile[]): void {
    if (this.isUpdatedReferenceFiles || this.toReferenceFileKeys(selection).sequenceEqual(this.toReferenceFileKeys(this.referenceFiles))) {
      return;
    }
    this.referenceFiles = selection.slice();
  }

  private toReferenceFileKeys(referenceFiles: IEditableFormatReferenceFile[]): Enumerable.IEnumerable<string> {
    return Enumerable.from(referenceFiles).select(e => e.key).orderBy(e => e);
  }

  @Watch("referenceFiles")
  onReferenceFilesUpdated(newValue: IEditableFormatReferenceFile[], oldValue: IEditableFormatReferenceFile[]): void {
    this.isUpdatedReferenceFiles = true;
    const referenceFileKeys = this.toReferenceFileKeys(this.referenceFiles);
    Enumerable.from(this.tableData).forEach(e => {
      const selected = referenceFileKeys.contains(e.key);
      this.$refs.table.toggleRowSelection(e, selected);
    });
    this.isUpdatedReferenceFiles = false;
  }
}
